import React from 'react';
import './EmbeddedAnalyticsSection.css';

export default function EmbeddedAnalyticsSection() {
  return (
    <section className="embed">
      <div className="embed-container">
        {/* Left content */}
        <div className="embed-content">
          <div className="embed-icon">▶</div>

          <h2 className="embed-title">Placeholder Lorem, ipsum dolor sit headline</h2>

          <p className="embed-subtitle">
            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Rem expedita aut ipsa, 
            provident atque sapiente aliquid dolorem sint illo nihil earum quidem dolorum 
            amet enim explicabo illum!
          </p>

          <ul className="embed-list">
            <li>
              <strong>Placeholder line 1</strong> –
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Rem expedita aut ipsa, 
            provident atque sapiente aliquid dolorem sint illo nihil earum quidem dolorum
            </li>

            <li>
              <strong>Placeholder line 2</strong> –
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Rem expedita aut ipsa, 
            provident atque sapiente aliquid dolorem sint illo nihil earum quidem dolorum
            </li>

            <li>
              <strong>Placeholder line 3</strong> –
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Rem expedita aut ipsa, 
            provident atque sapiente
            </li>
          </ul>

          <a href="#" className="embed-link">Learn more →</a>
        </div>

        {/* Right GIF */}
        <div className="embed-visual">
          {/* <img src="/analytics-demo.gif" alt="Embedded analytics demo" /> */}
        </div>
      </div>
    </section>
  );
}
